import ThisModule from "./Avatar";

export default ThisModule;
